import clsx from 'clsx'
import type { FunctionComponent } from 'react'
import style from './TabButtons.module.sass'

type TabButtonsProps = {
	changeTab: () => void
	id: string
	label: string
	activeId: string | undefined
	disabled?: boolean
	isTitle?: boolean
}

export const TabButtons: FunctionComponent<TabButtonsProps> = ({
	changeTab,
	id,
	label,
	activeId,
	isTitle = false,
	disabled = false,
}) => {
	const titleSplitArr = label.split('(')
	return (
		<button
			disabled={disabled}
			className={clsx(style.button, id === activeId && style.buttonActive)}
			onClick={changeTab}
		>
			{isTitle ? (
				<>
					{titleSplitArr.length > 1 ? (
						<>
							<h2 className={style.title}>{titleSplitArr[0]}</h2> ({titleSplitArr[1]}
						</>
					) : (
						<h2 className={style.title}>{label}</h2>
					)}
				</>
			) : (
				label
			)}
		</button>
	)
}
